import React, { useState, useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import { useDispatch, useSelector } from "react-redux";
import { getIndustry, getWithParentCategary } from "../../../../redux/categary/action";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import { descriptionvalidation, nospecialtitle } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import CommonCategoryOption from "../../../Common/CommonCategoryOption";
import CommonIndustryOption from "../../../Common/CommonIndustryOption";

const bxpDatatomap = [
  { title: (<>Product title <AsteriskLabel /></>), name: "title", placeholder: "Type here" },
  // { title: (<>Cover Image </>), name: "cover", placeholder: "Drag and drop or Browse file" },
  { title: (<>Description <AsteriskLabel /></>), name: "description", placeholder: "Type here" },
  { title: (<>Industry <AsteriskLabel /></>), name: "industry_id", placeholder: "Select industry" },
  { title: (<>Category <AsteriskLabel /></>), name: "category_id", placeholder: "Select Category" },
  // { title: (<>Sub Category </>), name: "sub_category_id", placeholder: "Select Sub Category" },
  { title: (<>Price <AsteriskLabel /></>), name: "price", placeholder: "Enter price" },
];

const validationSchema = Yup.object().shape({
  title: nospecialtitle,
  industry_id: Yup.string().required("Industry is required"),
  category_id: Yup.string().required("Category is required"),
  price: Yup.number().required("Price is required").moreThan(0, "Price should be more than zero"),
  description: descriptionvalidation,
});

const SyncParent = ({ values, setbxpData, updateindex, initialValues, setChangesIsThere }) => {
  const lastSynced = useRef("");
  const initialSnapshot = useRef(null);

  // Capture initialValues once on first render (or when the form key changes)
  if (initialSnapshot.current === null) {
    initialSnapshot.current = JSON.stringify(initialValues);
  }

  useEffect(() => {
    const currentValues = JSON.stringify(values);
    if (lastSynced.current !== currentValues) {
      if (updateindex === null && Object.keys(values).length > 0) {
        setbxpData((prev) => ({ ...prev, ...values }));
      }
      const hasChanges = currentValues !== initialSnapshot.current;
      setChangesIsThere(hasChanges);
      lastSynced.current = currentValues;
    }
  }, [values, updateindex, setbxpData, setChangesIsThere]);
  return null;
};

const Productdetails = ({ updateindex, bxpData, setbxpData, setActiveTab, setChangesIsThere }) => {
  const [loading, setLoading] = useState(null);
  const [image, setImage] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectCategory, setSelectCategory] = useState(null);
  const dispatch = useDispatch();

  const categarylist = useSelector((state) => state.categary.categarylist);
  const TheIndustryList = useSelector(({ categary: { industrylist } }) => industrylist);

  const initialValues = useMemo(() => {
    return {
      title: bxpData?.title || "",
      cover: bxpData?.cover || "",
      industry_id: bxpData?.industry_id || "",
      category_id: bxpData?.category_id || "",
      description: bxpData?.description || "",
      sub_category_id: bxpData?.sub_category_id || "",
      price: bxpData?.price || "",
    };
  }, [bxpData]);

  useEffect(() => {
    if (updateindex) {
      setImage(null);
    }
  }, [updateindex]);

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(getIndustry());
  }, [path]);

  useEffect(() => {
    if (bxpData?.industry_id) {
      setSelectedIndustry(bxpData?.industry_id);
    }
  }, [bxpData?.industry_id]);

  useEffect(() => {
    if (selectedIndustry) {
      dispatch(getWithParentCategary(selectedIndustry));
    }
  }, [selectedIndustry]);

  useEffect(() => {
    if (bxpData?.category_id && categarylist?.length) {
      const selectedCategory = categarylist.find((item) => item.id == bxpData?.category_id);
      setSelectCategory(selectedCategory ? { value: selectedCategory.id, label: selectedCategory.title } : null);
    } else if (updateindex == null) {
      setSelectCategory(null);
    }
  }, [updateindex, bxpData?.category_id, categarylist]);

  // Sync form values to parent state for drafts
  useEffect(() => {
    // This is now handled by SyncParent to avoid loops
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values };

    try {
      setbxpData(updatedData);
      setActiveTab("WorkSamples");
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <SyncParent
                values={formik.values}
                setbxpData={setbxpData}
                updateindex={updateindex}
                initialValues={initialValues}
                setChangesIsThere={setChangesIsThere}
              />
              <div>
                {bxpDatatomap.map((prop, key) => {
                  if (prop.name == "description") {
                    return (
                      <>
                        <CustomReactQuill
                          value={formik.values[prop.name]}
                          formik={formik}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                          style={{ color: "red" }}
                        />
                      </>
                    );
                  }
                  if (prop.name == "industry_id") {
                    return (
                      <CommonIndustryOption
                        key={key}
                        options={TheIndustryList}
                        formik={formik}
                        prop={prop}
                        setSelectedIndustry={setSelectedIndustry}
                        setSelectCategory={setSelectCategory}
                      />
                    );
                  }

                  if (prop.name == "category_id") {
                    return (
                      <>
                        <CommonCategoryOption
                          key={key}
                          formik={formik}
                          prop={prop}
                          options={categarylist}
                          selectCategory={selectCategory}
                          setSelectCategory={setSelectCategory}
                        />
                      </>
                    );
                  }
                  if (prop.name == "price") {
                    return (
                      <NumberInputBox
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                      />
                    );
                  }

                  return (
                    <FieldInput
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                })}
                <div className="button-container">
                  <button className="next-button w-100" type="submit">
                    {loading ? <LoginLoaderButton /> : "Next"}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Productdetails;
